/* eslint-disable */
export default {
  mute: 'Mute',
  unmute: 'Unmute',
  hangup: 'Hang up',
  reject: 'Reject',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
